export default {
	jp: [{
		"category": "お申込み方法について",
		"faqs": [{
			"question": "有料のサービスがどのようなものか見てみたいです。",
			"answer": "サンプルがありますのでご覧ください。サンプルは<a href='https://cdn2.cbredata.com/creis/videos/CREIS_SERVICE_JP.mp4'>こちら</a>"
		}, {
			"question": "有料のサービスの申し込みの流れが知りたいです",
			"answer": "有料のサービスの申し込みの流れをご覧ください。サービスの申込の流れは<a href='https://cdn2.cbredata.com/creis/manuals/Applying_for_membership_JP.pdf'>こちら</a>"
		}, {
			"question": "有料のサービスの種類にはどのようなものがありますか？",
			"answer": "オフィス、物流/インダストリアル、リテールの３セクターの中からご選択頂けます。レポートは一つ以上のセクターを申込みされると閲覧できます。有料のサービスの種類は<a href='https://creis.jp/?url=#pricing'>こちら</a>"
		}, {
			"question": "誰でも申し込めますか？",
			"answer": "お申込みはご法人様のみにてお願いしています。但しお客様の事業内容によってはお断りすることもありますのであらかじめご了承ください。"
		}, {
			"question": "一つの契約で何人まで利用できますか？",
			"answer": "一つの契約で10人まで利用できます。\n11アカウント以上を希望される場合は、5アカウント毎の追加が可能です。料金は5アカウント毎に基本料金の50％が加算されます。"
		}, {
			"question": "申込み後、有料のサービスが利用できるまでどのくらいかかりますか？",
			"answer": "<a href='https://auth.creis.jp/login?language=jp&partform=live'>お申し込み</a>受領後、５営業日～10営業日以内には請求書をご送付できます。ご入金が確認でき次第ご利用可能になります。"
		}, {
			"question": "どのような支払方法がありますか？",
			"answer": "支払は銀行振り込みでお願いいたします。"
		}, {
			"question": "分割払いはありますか？",
			"answer": "申し訳ございません。お支払いは一括でお願いしています。"
		}]
	}, {
		"category": "すでにご契約中の方へ（ログイン、ご契約内容の確認、アカウント情報の変更、ご退会について）",
		"faqs": [{
			"question": "現在契約期間中ですが、他のセクターのサービスを追加で申込をしたいです。追加の申込は可能ですか？",
			"answer": "契約変更の手続きが必要となりますが、可能です。まずは追加を希望するセクターなどの情報をお問合せください。お問合せは<a href='mailto:creissupport@cbre.co.jp'>こちら</a>（回答に２営業日程度かかります。）"
		}, {
			"question": "会社が引っ越しします。必要な手続きはありますか？",
			"answer": "契約ご担当者様よりログイン後のアカウント情報画面にて住所等連絡先を更新してください。"
		}, {
			"question": "組織改編があり部署名が変わりました。",
			"answer": "契約ご担当者様よりログイン後のアカウント情報画面にて部署名を更新してください。"
		}, {
			"question": "異動がありました。アカウント保有者が変わります。",
			"answer": "契約ご担当者様よりログイン後のアカウント管理画面にてアカウント保有者情報を更新してください。"
		}, {
			"question": "他にもサービスを使いたい人が現れました。利用者追加は可能ですか？\n",
			"answer": "ご契約の部署で10名以内でしたら、特に手続きや費用なしでの追加が可能です。アカウント管理画面より追加をお願いします。利用者が11名以上になる場合は、5アカウント毎の追加が可能です。料金は5アカウント毎に基本料金の50％が加算されます。ご希望の場合はお問合せください。お問合せは<a href='mailto:creissupport@cbre.co.jp'>こちら</a>"
		}, {
			"question": "退会したいのですが、どのようにすればよいでしょうか？",
			"answer": "サービス事務局<a href='mailto:creissupport@cbre.co.jp'>creissupport@cbre.co.jp</a>までメールをお送りください。メール受領次第、アカウントを停止いたします。"
		}, {
			"question": "契約を途中解約したいので残りの期間分払い戻しして欲しいです。",
			"answer": "申し訳ございません。<a href='https://cdn2.cbredata.com/creis/Terms_of_Use_JP.pdf'>払い戻しはおこなっておりません</a>のでなにとぞご了承ください。"
		}]
	}, {
		"category": "レポート、動画などコンテンツについて",
		"faqs": [{
			"question": "データはいつ更新されていますか？",
			"answer": "マーケットデータは四半期ごと（1月、4月、7月、10月）の更新です。"
		}, {
			"question": "いつレポートが出ますか？",
			"answer": "毎週火曜日にメールでお知らせいたします。"
		}, {
			"question": "レポートの内容を社内社外で利用したいのですが？",
			"answer": "<a href='https://cdn2.cbredata.com/creis/Terms_of_Use_JP.pdf'>約款　第7条（利用条件等）</a>をご覧ください。"
		}, {
			"question": "レポート、動画の内容について問合せしたいです。どうすればよいですか？",
			"answer": "セクター、レポート名または動画名とともにご質問を<a href='mailto:creissupport@cbre.co.jp'>creissupport@cbre.co.jp</a>へお送りください。"
		}]
	}],

	en: [{
		"category": "How to apply",
		"faqs": [{
			"question": "What are some examples of the paid services you provide?",
			"answer": "Please view the samples available <a href='https://cdn2.cbredata.com/creis/videos/CREIS_SERVICE_EN.mp4'>here</a>."
		}, {
			"question": "How do I go about applying for paid services?",
			"answer": "Please view the application procedures for paid services <a href='https://cdn2.cbredata.com/creis/manuals/Applying_for_membership_EN.pdf'>here</a>."
		}, {
			"question": "What different types of paid service do you offer?",
			"answer": "You can select from three sectors including Office, Logistics and Retail. Reports can be viewed by applying to one or more sectors. A list of paid services can be found <a href='https://creis.jp/?url=#pricing'>here</a>."
		}, {
			"question": "Is anyone eligible to apply?",
			"answer": "Only corporate clients are eligible to apply. Please note that applications may be rejected depending on the applicant’s business field."
		}, {
			"question": "How many people can use the service under a single subscription?",
			"answer": "We provide 10 accounts for a single subscription. For those who require Additional accounts are available for purchase in blocks of five. For each additional block, 50% of the base rate will be added to the fee."
		}, {
			"question": "How long does it take after applying before paid services can be used?",
			"answer": "An invoice will be sent to you in 5-10 working days after your <a href='https://auth.creis.jp/login?language=en&partform=live'>application</a> is received. Once payment of the invoice is confirmed, you will have immediate access to the services."
		}, {
			"question": "What payment methods do you offer?",
			"answer": "Payment is by bank transfer only."
		}, {
			"question": "Can payment be made in installments?",
			"answer": "Only lump sum payments are accepted."
		}]
	}, {
		"category": "Help for subscribers (logging in, contract confirmation, account detail changes, cancelling subscription)",
		"faqs": [{
			"question": "I am currently a subscriber, and would like to add services of another sector. Is this possible?",
			"answer": "This is possible, although your subscription details will need to be changed. Please begin by contacting us <a href='mailto:creissupport@cbre.co.jp'>here</a> with details of the sector or sectors you want to add. (Approximately two working days will be required for a reply.)"
		}, {
			"question": "My company is relocating. Is there anything I should do?",
			"answer": "Please make the necessary amendments (address, contact details, etc.) on your subscriber page after logging in."
		}, {
			"question": "My department name has changed. Is there anything I should do?",
			"answer": "Please make the necessary amendments to the department name on your subscriber page after logging in."
		}, {
			"question": "The name of the account holder will change shortly. Is there anything I should do?",
			"answer": "Please make the necessary amendments to the account holder names on your subscriber page after logging in."
		}, {
			"question": "Can I add new users?",
			"answer": "If you currently have fewer than 10 accounts, then no additional paperwork or costs are required so long as the revised number of accounts remain at or fewer than 10. Simply add the new account via your subscriber page.\nIf the revised number of accounts exceeds 10, you will need to purchase additional accounts in blocks of five. For each additional block, 50% of the base rate will be added to the fee. Please inquire <a href='mailto:creissupport@cbre.co.jp'>here</a>."
		}, {
			"question": "How do I cancel my subscription?",
			"answer": "Please contact your customer representative via email at <a href='mailto:creissupport@cbre.co.jp'>creissupport@cbre.co.jp</a>. Once your email has been processed, your subscription will be cancelled."
		}, {
			"question": "If I cancel my subscription before its full term, can I be refunded for the remaining amount?",
			"answer": "Unfortunately, <a href='https://cdn2.cbredata.com/creis/Terms_of_Use_EN.pdf'>partial refunds are not available</a>. Thank you for your understanding."
		}]
	}, {
		"category": "About reports, videos and other content",
		"faqs": [{
			"question": "How often is the data updated?",
			"answer": "Market data is updated quarterly (in January, April, July, and October). "
		}, {
			"question": "When are reports published?",
			"answer": "Subscribers will be notified via email every Tuesday."
		}, {
			"question": "Can I use the content of the report within or outside my organization?",
			"answer": "Please refer to <a href='https://cdn2.cbredata.com/creis/Terms_of_Use_EN.pdf'>Article 7 (Usage Conditions, etc)</a> of the subscription contract."
		}, {
			"question": "I have a question regarding the content of a report or video. What should I do?",
			"answer": "Please send all questions to <a href='mailto:creissupport@cbre.co.jp'>creissupport@cbre.co.jp</a>. Please be sure to include the name of the sector and report or video in any queries you may have."
		}]
	}]

}